import { useMutation } from '@apollo/client';
import { DELETE_NOTIFICATION_MUTATION } from '../../mutations';

export function useDeleteNotificationMutation() {
    return useMutation( DELETE_NOTIFICATION_MUTATION );
}
